enum AlarmCategory {
    Base = 0,
    Static = 1,
    Dynamic = 2,
}

export { AlarmCategory }
